import { render, staticRenderFns } from "./PeriodPriceTable.vue?vue&type=template&id=85162e10&scoped=true&lang=true"
import script from "./PeriodPriceTable.vue?vue&type=script&lang=js"
export * from "./PeriodPriceTable.vue?vue&type=script&lang=js"
import style0 from "./PeriodPriceTable.vue?vue&type=style&index=0&id=85162e10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85162e10",
  null
  
)

export default component.exports